export default __webpack_public_path__ + "static/media/rectangulo-rosa.c7b5d0b5.svg";